module.exports = __webpack_public_path__ + "static/13-58510d750780eb8576292327008845b2.jpg";